module.exports = __webpack_public_path__ + "static/media/ht-call.361e901a.png";